import { METADATA_KIND } from "@/consts/metadata";

export default {
  metadatas: null,
  totalMetadatas: null,
  metadata: null
};

export function getMetadataDefaultState(kind) {
  if (!kind) {
    kind = METADATA_KIND.CUSTOMER;
  }
  return {
    kind,
    is_personaly_identifiable: false,
    is_personal_data: false,
    type: null,
    name: ""
  };
}
